module.exports = __webpack_public_path__ + "img/overworked-employee.afe7ae88.svg";